import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';
import { HTMLtoJSX, removeTagsFromString } from '../../../../../../helpers';
import { SubTitle } from '../../styles';

export const HeroModuleSubTitle = ({ text, colorType, style }) => {
  const { location } = useSelector(selectPageConfig);

  if (!text) {
    return null;
  }

  return (
    <SubTitle className="formatted-text" colorType={colorType} style={style}>
      {HTMLtoJSX(
        removeTagsFromString(text, ['br', 's', 'em', 'u', 'strong', 'a']),
        location,
      )}
    </SubTitle>
  );
};

HeroModuleSubTitle.propTypes = {
  text: PropTypes.string,
  colorType: PropTypes.string,
};
